import { createElement, useEffect, useRef } from 'react';

type Props = {
  html: string;
  allowRerender?: boolean;
  renderAs?: string;
  [x: string]: any;
};

// This component can execute HTML <script> tags
// Be careful if you're using it!
const DangerouslySetHtmlContent = (props: Props): React.ReactElement => {
  const { html, allowRerender, renderAs, ...rest } = props;

  const divRef = useRef(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!isFirstRender.current) return;
    if (!html || !divRef.current) return null;

    isFirstRender.current = Boolean(allowRerender);

    const slotHtml = document.createRange().createContextualFragment(html);
    divRef.current.innerHTML = '';
    divRef.current.appendChild(slotHtml);
  }, [html, divRef]);

  return createElement(renderAs || 'div', { ...rest, ref: divRef });
};

export default DangerouslySetHtmlContent;
